import type { IconBaseProps } from './types';

/**
 * Satellite icon from Lucide (MIT license).
 * Replaces CiSatellite1 / LiaSatelliteSolid from react-icons.
 */
export const SatelliteIcon = ({
  size = '1em',
  color = 'currentColor',
  title,
  ...props
}: IconBaseProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {title && <title>{title}</title>}
    <path d="m13.5 6.5-3.148-3.148a1.205 1.205 0 0 0-1.704 0L6.352 5.648a1.205 1.205 0 0 0 0 1.704L9.5 10.5" />
    <path d="M16.5 7.5 19 5" />
    <path d="m17.5 10.5 3.148 3.148a1.205 1.205 0 0 1 0 1.704l-2.296 2.296a1.205 1.205 0 0 1-1.704 0L13.5 14.5" />
    <path d="M9 21a6 6 0 0 0-6-6" />
    <path d="M9.352 10.648a1.205 1.205 0 0 0 0 1.704l2.296 2.296a1.205 1.205 0 0 0 1.704 0l4.296-4.296a1.205 1.205 0 0 0 0-1.704l-2.296-2.296a1.205 1.205 0 0 0-1.704 0z" />
  </svg>
);
